import { render, staticRenderFns } from "./ModalForSharding.vue?vue&type=template&id=0b2ca15f&"
import script from "./ModalForSharding.vue?vue&type=script&lang=js&"
export * from "./ModalForSharding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports